/* eslint-disable jsx-a11y/media-has-caption */
import React, { Fragment, useState } from 'react';
import * as ShowMediaModal from '@/app/store/actions';
import { useDispatch } from 'react-redux';
import Close from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import makeStyles from '@material-ui/styles/makeStyles';
import PlayArrowOutlined from '@material-ui/icons/PlayArrowOutlined';
import OnlyMediaComponent from './OnlyMediaComponent';

const useStyles = makeStyles(() => ({
	backDrop: {
		backdropFilter: 'blur(10px)',
		backgroundColor: 'rgba(0,0,30,0.4)',
	},
}));

const MediaRenderer = ({ media, photo, video, videoThumbnail }) => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const [imageError, setImageError] = useState(false);
	const [pictureLarge, setPictureLarge] = useState(null);
	const classes = useStyles();
	const dispatch = useDispatch();

	const handleImageLoad = () => {
		setImageLoaded(true);
	};

	const handleImageError = () => {
		setImageError(true);
	};

	const showMoreMedia = () => {
		dispatch(
			ShowMediaModal.openMediaDialog({
				children: <OnlyMediaComponent media={media} />,
			}),
		);
	};

	if (photo) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<button
								className="self-end cursor-pointer absolute profile-close"
								onClick={() => setPictureLarge(null)}
								type="button"
							>
								<Close />
							</button>
							<img
								alt=""
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				<button onClick={() => setPictureLarge(photo)} type="button">
					<img
						alt=""
						onError={handleImageError}
						onLoad={handleImageLoad}
						src={photo}
						style={{
							margin: '16px 0px',
							borderRadius: '11px',
							height: 203,
							width: 373,
							objectFit: 'cover',
							display: imageLoaded ? 'block' : 'none',
						}}
					/>
				</button>
				{!imageLoaded && !imageError ? <div>Loading...</div> : null}
			</>
		);
	}
	if (video) {
		return (
			<video
				controls
				poster={videoThumbnail}
				src={video}
				style={{
					margin: '16px 0px',
					borderRadius: '11px',
					height: 203,
					width: 373,
					objectFit: 'cover',
				}}
			/>
		);
	}
	if (media.length === 1) {
		console.log(media[0]);
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<button
								className="self-end cursor-pointer absolute profile-close"
								onClick={() => setPictureLarge(null)}
								type="button"
							>
								<Close />
							</button>
							<img
								alt=""
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				{media[0].type === 'image' ? (
					<button onClick={() => setPictureLarge(media[0].link)} type="button">
						<img
							alt=""
							onError={handleImageError}
							onLoad={handleImageLoad}
							src={media[0].link}
							style={{
								margin: '16px 0px',
								borderRadius: '11px',
								height: 203,
								width: 373,
								objectFit: 'cover',
								display: imageLoaded ? 'block' : 'none',
							}}
						/>
					</button>
				) : (
					<video
						controls
						poster={media[0].thumb}
						src={media[0].link}
						style={{
							margin: '16px 0px',
							borderRadius: '11px',
							height: 203,
							width: 373,
							objectFit: 'cover',
						}}
					/>
				)}
				{!imageLoaded && !imageError ? <div>Loading...</div> : null}
			</>
		);
	}
	if (media.length === 2) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<button
								className="self-end cursor-pointer absolute profile-close"
								onClick={() => setPictureLarge(null)}
								type="button"
							>
								<Close />
							</button>
							<img
								alt=""
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				<div
					className="flex"
					style={{
						margin: '16px 0px',
						borderRadius: '11px',
						height: 203,
						width: 373,
						objectFit: 'cover',
					}}
				>
					{media.map((item) => {
						return (
							<Fragment key={item.id}>
								{item.type === 'image' ? (
									<button onClick={() => setPictureLarge(item.link)} type="button">
										<img
											alt=""
											onError={handleImageError}
											onLoad={handleImageLoad}
											src={item.link}
											style={{
												margin: '16px 0px',
												width: '50%',
												objectFit: 'cover',
												display: imageLoaded ? 'block' : 'none',
											}}
										/>
									</button>
								) : (
									<video
										controls
										poster={item.thumb}
										src={item.link}
										style={{
											margin: '16px 0px',
											width: '50%',
											objectFit: 'cover',
										}}
									/>
								)}
								{!imageLoaded && !imageError ? <div>Loading...</div> : null}
							</Fragment>
						);
					})}
				</div>
			</>
		);
	}
	if (media.length > 2) {
		return (
			<>
				{pictureLarge ? (
					<Dialog
						BackdropProps={{
							classes: {
								root: classes.backDrop,
							},
						}}
						onClose={() => {
							setPictureLarge(null);
						}}
						open={pictureLarge}
					>
						<div className="larg_image flex flex-col">
							<button
								className="self-end cursor-pointer absolute profile-close"
								onClick={() => setPictureLarge(null)}
								type="button"
							>
								<Close />
							</button>
							<img
								alt=""
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={pictureLarge}
								style={{ display: imageLoaded ? 'block' : 'none' }}
							/>
						</div>
					</Dialog>
				) : null}
				<div
					className="flex"
					style={{
						height: 200,
						width: 373,
						objectFit: 'cover',
					}}
				>
					{media[0]?.type === 'image' ? (
						<button onClick={() => setPictureLarge(media[0].link)} type="button">
							<img
								alt=""
								onError={handleImageError}
								onLoad={handleImageLoad}
								src={media[0]?.link}
								style={{
									height: '100%',
									width: 275,
									objectFit: 'cover',
									display: imageLoaded ? 'block' : 'none',
								}}
							/>
						</button>
					) : (
						<video
							controls
							poster={media[0]?.thumb}
							src={media[0]?.link}
							style={{
								height: '100%',
								width: 275,
								objectFit: 'cover',
							}}
						/>
					)}
					<div className="flex flex-col">
						{media?.slice(1, 3).map((item, index) => {
							return index !== 1 ? (
								<div key={index}>
									{item?.type === 'image' ? (
										<button onClick={() => setPictureLarge(item.link)} type="button">
											<img
												alt=""
												onError={handleImageError}
												onLoad={handleImageLoad}
												src={item?.link}
												style={{
													width: 98,
													height: 100,
													objectFit: 'cover',
													display: imageLoaded ? 'block' : 'none',
												}}
											/>
										</button>
									) : (
										<div className="relative" key={index}>
											<video
												controls
												poster={item?.thumb}
												src={item?.link}
												style={{
													width: 98,
													height: 100,
													objectFit: 'cover',
												}}
											/>
											<button
												className="black-cover text-white cursor-pointer"
												onClick={() => {
													showMoreMedia();
												}}
												type="button"
											>
												<PlayArrowOutlined />
											</button>
										</div>
									)}
									{!imageLoaded && !imageError ? <div>Loading...</div> : null}
								</div>
							) : (
								// put a black shade over the last image and show count of remaining images / videos
								<div className="relative" key={index}>
									{item?.type === 'image' ? (
										<button onClick={() => setPictureLarge(item.link)} type="button">
											<img
												alt=""
												onError={handleImageError}
												onLoad={handleImageLoad}
												src={item?.link}
												style={{
													width: 98,
													height: 100,
													objectFit: 'cover',
												}}
											/>
										</button>
									) : (
										<div className="relative" key={index}>
											<video
												controls
												poster={item?.thumb}
												src={item?.link}
												style={{
													width: 98,
													height: 100,
													objectFit: 'cover',
												}}
											/>
											{media.length === 3 ? (
												<button
													className="black-cover text-white cursor-pointer"
													onClick={() => {
														showMoreMedia();
													}}
													type="button"
												>
													<PlayArrowOutlined />
												</button>
											) : null}
										</div>
									)}
									{media?.length > 3 ? (
										<button
											className="black-cover text-white cursor-pointer"
											onClick={() => {
												showMoreMedia();
											}}
											type="button"
										>
											+{media?.length - 3}
										</button>
									) : null}
								</div>
							);
						})}
					</div>
				</div>
			</>
		);
	}
	return null;
};

export default MediaRenderer;
